"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.costReports.title': 'Informes de Costos',
    'reports.costReports.description': 'Ver costos de uso de IA y análisis',
};
